import * as Cesium from 'cesium';
import * as turf from '@turf/turf';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
import {Cartesian3} from "cesium";
/**
 * 员工图层
 */
export default class WorkerLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.WORKER;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.map((item,index) =>{
            self.addEntity(item);
        });
    }

    updateEntities(data){
        let self=this;
        data.map((item,index) =>{
            if(item.longitude&&item.latitude){
                item.factor=0;
                let entity=self.getEntityById(item.id);
                if(entity){
                    entity.attributes.factor=0;
                    entity.position=new Cesium.CallbackProperty(()=>{
                        if(entity.attributes.factor<6000){
                            entity.attributes.factor=entity.attributes.factor+1;
                        }else{
                            entity.attributes.longitude=item.longitude;
                            entity.attributes.latitude=item.latitude;
                        }
                        //动态更新位置
                        return Cesium.Cartesian3.lerp(
                            Cesium.Cartesian3.fromDegrees(entity.attributes.longitude,entity.attributes.latitude,4),
                            Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude,4),
                            entity.attributes.factor/6000.0,new Cesium.Cartesian3());
                    },false);
                    entity.attributes.pathIndex=item.pathIndex;
                    let entity1=self.getEntityById("model"+item.id);
                    let bearing = turf.bearing(turf.point([entity.attributes.longitude,entity.attributes.latitude]), turf.point([item.longitude,item.latitude]));
                    entity1.attributes.factor=0;
                    entity1.position=new Cesium.CallbackProperty(()=>{
                        if(entity1.attributes.factor<6000){
                            entity1.attributes.factor=entity1.attributes.factor+1;
                        }else{
                            entity1.attributes.longitude=item.longitude;
                            entity1.attributes.latitude=item.latitude;
                        }
                        //动态更新位置
                        return Cesium.Cartesian3.lerp(
                            Cesium.Cartesian3.fromDegrees(entity1.attributes.longitude,entity1.attributes.latitude,2),
                            Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude,2),
                            entity1.attributes.factor/6000.0,new Cesium.Cartesian3());
                    },false);
                    entity1.orientation=Cesium.Transforms.headingPitchRollQuaternion(
                        Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, 2),
                        new Cesium.HeadingPitchRoll(
                            Cesium.Math.toRadians(bearing-80),    // 设置这个属性即可（顺时针旋转的角度值）
                            Cesium.Math.toRadians(0),
                            Cesium.Math.toRadians(0)
                        )
                    )
                }else{
                    self.addEntity(item);
                }

            }
        });
    }

    addEntity(data){
        data.layerName=this.layerName;
        if(data.longitude&&data.latitude){
            data.icon=data.icon||'1';
            let entity=new Cesium.Entity({
                position: Cesium.Cartesian3.fromDegrees(data.longitude,data.latitude, 4),
                id:data.id,
                attributes:data,
                //立广告牌
                billboard :{
                    image : "/static/imgs/employee/view"+data.icon+".png",
                    show : true,
                    width : 32,
                    height : 32,
                    pixelOffset:new Cesium.Cartesian2(0, 0),
                    heightReference:Cesium.HeightReference.RELATIVE_TO_GROUND
                },
                label:{
                    text : data.name,
                    style:Cesium.LabelStyle.FILL_AND_OUTLINE,
                    color :Cesium.Color.fromCssColorString('#fff'),
                    backgroundColor:Cesium.Color.fromCssColorString('#F61111').withAlpha(0.6),
                    backgroundPadding:new Cesium.Cartesian2(7, 5),
                    outlineColor:Cesium.Color.fromCssColorString('#2D3635'),
                    outlineWidth:2,
                    font: "16px Helvetica",
                    showBackground : true,
                    pixelOffset:new Cesium.Cartesian2(0, -24),
                    //eyeOffset:new Cartesian3(0,0,10),
                    heightReference:Cesium.HeightReference.RELATIVE_TO_GROUND
                }
            })
            this.dataSource.entities.add(entity);
            entity=new Cesium.Entity({
                position: Cesium.Cartesian3.fromDegrees(data.longitude,data.latitude, 2),
                id:"model"+data.id,
                attributes:data,
                orientation: Cesium.Transforms.headingPitchRollQuaternion(
                    Cesium.Cartesian3.fromDegrees(data.longitude,data.latitude, 2),
                    new Cesium.HeadingPitchRoll(
                        Cesium.Math.toRadians(0),    // 设置这个属性即可（顺时针旋转的角度值）
                        Cesium.Math.toRadians(0),
                        Cesium.Math.toRadians(0)
                    )
                ),
                model: {
                    uri : "/static/imgs/model/1.glb",
                    scale:1
                }
            })
            this.dataSource.entities.add(entity);
        }
    }


    /**
     * 计算实体的位置矩阵
     * @param entity
     * @param time
     * @returns {*}
     */
   computeModelMatrix(entity, time){
        let position = Cesium.Property.getValueOrUndefined(
            entity.position,
            time,
            new Cesium.Cartesian3()
        );
        if (!Cesium.defined(position)) {
            return undefined;
        }
        let orientation = Cesium.Property.getValueOrUndefined(
            entity.orientation,
            time,
            new Cesium.Quaternion()
        );
        let modelMatrix;
        if (!Cesium.defined(orientation)) {
            modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(
                position,
                undefined,
                new Cesium.Matrix4()
            );
        } else {
            modelMatrix = Cesium.Matrix4.fromRotationTranslation(
                Cesium.Matrix3.fromQuaternion(orientation, new Cesium.Matrix3()),
                position,
                new Cesium.Matrix4()
            );
        }
        return modelMatrix;
    };

    /**
     * 计算实体的当前旋转状态
     * @param entity
     */
    getEntityHPR(entity){
        let self=this;
        return Cesium.Transforms.fixedFrameToHeadingPitchRoll(
            self.computeModelMatrix(
                entity,
                viewer.clock.currentTime || Cesium.JulianDate.now()
            )
        );
    };


    /**
     * 模型旋转
     * @param model
     * @param startHpr
     * @param endHpr
     * @param seconds
     * @param startPoint
     * @param endPoint
     */
    modelRotate(
        model,
        startHpr,
        endHpr,
        seconds,
        startPoint,
        endPoint
    ){
        let self=this;
        let startQ = Cesium.Transforms.headingPitchRollQuaternion(
            startPoint || self.getEntityPosition({ Cesium, viewer }, model),
            new Cesium.HeadingPitchRoll(
                Cesium.Math.toRadians(startHpr.heading),
                Cesium.Math.toRadians(startHpr.pitch),
                Cesium.Math.toRadians(startHpr.roll)
            )
        );
        let stopQ = Cesium.Transforms.headingPitchRollQuaternion(
            endPoint || self.getEntityPosition({ Cesium, viewer }, model),
            new Cesium.HeadingPitchRoll(
                Cesium.Math.toRadians(endHpr.heading),
                Cesium.Math.toRadians(endHpr.pitch),
                Cesium.Math.toRadians(endHpr.roll)
            )
        );
        let start = window.viewer.clock.currentTime || Cesium.JulianDate.now();
        let stop = Cesium.JulianDate.addSeconds(
            start,
            seconds,
            new Cesium.JulianDate()
        );
        let stop_ = Cesium.JulianDate.addSeconds(
            start,
            seconds + 99999999,
            new Cesium.JulianDate()
        );
        let sampled = new Cesium.SampledProperty(Cesium.Quaternion);
        sampled.addSample(start, startQ);
        sampled.addSample(stop, stopQ);
        sampled.addSample(stop_, stopQ);
        model.orientation = sampled;
    }

    /**
     * 获取当前实体的位置
     * @param entity
     * @returns {*}
     */
    getEntityPosition = (entity) => {
        return (
            entity.position._value ||
            Cesium.Property.getValueOrUndefined(
                entity.position,
                window.viewer.clock.currentTime || Cesium.JulianDate.now(),
                new Cesium.Cartesian3()
            )
        );
    }

    /**
     * 模型移动函数 米
     * @param model
     * @param meters
     * @param seconds
     */
    modelMove2Position(
        model,
        position,
        seconds
    ){
        if (!model || !position || !seconds || !position.lng) {
            return;
        }
        let self=this;
        let modelNowPosition = Cesium.Math.toDegrees(
            self.getEntityPosition(model)
        );
        if (modelNowPosition && modelNowPosition.lng) {
            self.modelMove(model, modelNowPosition, position, seconds);
        }
    };

    /**
     * 模型移动函数
     * @param model
     * @param startPosition 起点位置
     * @param endPosition 终点位置
     * @param seconds 秒数
     */
    modelMove(
        model,
        startPosition,
        endPosition,
        seconds
    ) {
        if (model) {
            let p1 = {
                lng: parseFloat(startPosition.lng),
                lat: parseFloat(startPosition.lat),
                alt: parseFloat(startPosition.alt),
            };
            let p2 = {
                lng: parseFloat(endPosition.lng),
                lat: parseFloat(endPosition.lat),
                alt: parseFloat(endPosition.alt),
            };
            let start = viewer.clock.currentTime || Cesium.JulianDate.now();
            let stop = Cesium.JulianDate.addSeconds(
                start,
                seconds,
                new Cesium.JulianDate()
            );
            let stop_ = Cesium.JulianDate.addSeconds(
                start,
                seconds + 99999999,
                new Cesium.JulianDate()
            );
            if (
                typeof model.position !== "undefined" &&
                typeof model.position.addSample !== "undefined"
            ) {
                model.position.removeSamples(
                    new Cesium.TimeInterval({
                        start: start,
                        stop: stop_,
                    })
                );
                model.position.addSample(start, toCartesian({ Cesium, viewer }, p1));
                model.position.addSample(stop, toCartesian({ Cesium, viewer }, p2));
                model.position.addSample(stop_, toCartesian({ Cesium, viewer }, p2));
            } else {
                let property = new Cesium.SampledPositionProperty();
                property.addSample(start, toCartesian({ Cesium, viewer }, p1));
                property.addSample(stop, toCartesian({ Cesium, viewer }, p2));
                property.addSample(stop_, toCartesian({ Cesium, viewer }, p2));
                model.position = property;
            }
        }
    }


};
